import React, {Component} from 'react'

import AppBar from 'material-ui/AppBar'

import {withRouter} from 'react-router'
import { withStyles } from 'material-ui/styles'
import frameworkStyles from '../components/FrameworkStyles'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import {ArrowBack as BackIcon} from 'material-ui-icons'


let Wrapper = ({WrappedComponent, back_link, title, classes, history, ...rest}) =>{

  let onBack = () => {history.replace(back_link)}

  let Header = false
  if (typeof(title) == 'string')
  {
    Header = (<Typography type="title" component="h2" className={classes.appTitle}>
                {title}
              </Typography>)
  }
  else if (typeof(title) == 'function')
  {
    let Title = title
    Header = <Title className={classes.headerComponent} {...rest} />
  }

  console.log({WrappedComponent, title, back_link})
  return (
    <div className={classes.root}>
    <AppBar 
      position='fixed' 
      className={classes.appBar}
      elevation={2}
      color="primary"
    >
      <Toolbar disableGutters={true}>
        {back_link &&
          <IconButton className={classes.menuButton} aria-label="Back" onClick={onBack}>
            <BackIcon />
          </IconButton>
        }
        {Header && Header}
      </Toolbar>
    </AppBar>
    <div className={classes.content}>
      <WrappedComponent {...rest} history={history} />
    </div>
  </div>
  )
}

let StyledWrapper = withStyles(frameworkStyles)(Wrapper)
let RoutedWrapper = withRouter(StyledWrapper)

let inFullScreen = (title, back_link) => (WrappedComponent) => props => (
  <RoutedWrapper title={title} back_link={back_link} WrappedComponent={WrappedComponent} {...props} />
)

export default inFullScreen
// export default (title, back_link) => (withStyles(styles)(inFullScreen(title, back_link)))




// WEBPACK FOOTER //
// ./src/hoc/full-screen.js